import './App.css';

import { React, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Careers from './Careers';
import Editorial from './Editorial';
import Videographer from './Videographer';
import Writer from './Writer';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollIntoView({ behavior: "smooth" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/careers" element={<Careers />}/>
        <Route path="/careers/videographer" element={<Videographer />}/>
        <Route path="/careers/senior-editor" element={<Editorial />}/>
        <Route path="/careers/senior-writer" element={<Writer />}/>
      </Routes>
    </Router>
  );
}

export default App;
